import { CompanyFinancialMonitoring } from '../components';
import { useCompanyFinancialMonitoring } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyFinancialMonitoringStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, onSubmit, submitLoading, goToBack, hasBranches } =
    useCompanyFinancialMonitoring();

  return (
    <CompanyFinancialMonitoring
      canGoBack={canGoBack}
      hasBranches={hasBranches}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
